module.exports = __webpack_public_path__ + "static/media/test2_4.4b31d5e8.png";